import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import React from "react";
import __ from "src/utils/Translations";
import { reimpersonate } from "src/utils/RoleBasedSecurity/Session";
import PeIcon from "src/Components/Icons/PeIcon";

function SidebarMenuAnchor({
  id,
  href,
  before,
  isOpen,
  isActive,
  hasActiveChild,
  hasSubmenu,
  to,
  icon,
  label,
  toggleSubmenu,
  isTargetBlank,
}) {
  const handleClick = (event, href, action) => {
    event.preventDefault();
    if (action === "reimpersonate") {
      reimpersonate();
    }
    window.location.href = href;
  };

  if (href && before) {
    return (
      <a
        data-t1={id}
        className={`metismenu-link${hasActiveChild ? " has-active-child" : ""}${
          isActive ? " active" : ""
        }`}
        href={href}
        onClick={(event) => handleClick(event, href, before)}
      >
        <PeIcon name={icon} className="metismenu-icon" />
        {__(label)}
      </a>
    );
  }

  if (href) {
    return (
      <a
        data-t1={id}
        className={`metismenu-link${hasActiveChild ? " has-active-child" : ""}${
          isActive ? " active" : ""
        }`}
        href={href}
        target={isTargetBlank ? "_blank" : "_self"}
        rel={isTargetBlank ? "noreferrer noopener" : undefined}
      >
        <PeIcon name={icon} className="metismenu-icon" />
        {__(label)}
      </a>
    );
  }

  return (
    <Link
      data-t1={id}
      className={`metismenu-link${hasActiveChild ? " has-active-child" : ""}${
        isActive ? " active" : ""
      }`}
      to={to || "#"}
      href={href}
      onClick={() => toggleSubmenu(id)}
    >
      <PeIcon name={icon} className="metismenu-icon" />
      {__(label)}
      {hasSubmenu ? (
        <PeIcon
          name="pe-7s-angle-down"
          className={`metismenu-state-icon caret-left${
            isOpen ? " rotate-minus-90" : ""
          }`}
        />
      ) : null}
    </Link>
  );
}

SidebarMenuAnchor.propTypes = {
  id: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  before: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  isActive: PropTypes.bool.isRequired,
  hasActiveChild: PropTypes.bool.isRequired,
  hasSubmenu: PropTypes.bool.isRequired,
  to: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  toggleSubmenu: PropTypes.func.isRequired,
  isTargetBlank: PropTypes.bool,
};

SidebarMenuAnchor.defaultProps = {
  isTargetBlank: false,
};

export default SidebarMenuAnchor;
